// src/common/ThemeToggle.js
import React, { useRef } from "react";
import { IconButton, alpha, Box } from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { keyframes } from "@mui/system";

const iconSpin = keyframes`
  0%   { transform: rotate(-90deg) scale(0.5); opacity: 0; }
  100% { transform: rotate(0deg)   scale(1);   opacity: 1; }
`;

const ThemeToggle = ({ isDark, toggleColorMode, theme, size = "medium" }) => {
  const btnRef = useRef(null);

  const handleToggle = () => {
    const btn = btnRef.current;
    if (!btn) return;

    const rect = btn.getBoundingClientRect();

    // Pass { x, y } origin → useCustomTheme hook picks it up
    toggleColorMode({
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    });
  };

  const isSmall = size === "small";
  const accentColor = isDark
    ? theme.palette.warning.main
    : theme.palette.primary.main;

  return (
    <IconButton
      ref={btnRef}
      onClick={handleToggle}
      size="small"
      sx={{
        width: isSmall ? 32 : 36,
        height: isSmall ? 32 : 36,
        bgcolor: alpha(accentColor, 0.08),
        border: `1px solid ${alpha(accentColor, 0.2)}`,
        transition: "all 0.25s ease",
        "&:hover": {
          bgcolor: alpha(accentColor, 0.15),
          transform: "scale(1.1)",
        },
      }}
    >
      <Box
        key={isDark ? "dark" : "light"}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: `${iconSpin} 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)`,
        }}
      >
        {isDark ? (
          <Brightness7Icon
            sx={{
              fontSize: isSmall ? 16 : 18,
              color: theme.palette.warning.main,
            }}
          />
        ) : (
          <Brightness4Icon
            sx={{
              fontSize: isSmall ? 16 : 18,
              color: theme.palette.primary.main,
            }}
          />
        )}
      </Box>
    </IconButton>
  );
};

export default ThemeToggle;
